import { IIconBase } from '..'

const noResultsIcon = ({ height = 60, width = 98 }: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 98 60'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        width='97.2076'
        height='59.5074'
        transform='translate(0.39624)'
        fill='white'
        fillOpacity='0.01'
      />
      <path
        opacity='0.8'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.9141 11.1486C20.9137 8.00458 21.8439 6.04708 22.7033 5.27533C25.0832 3.13933 28.3737 4.30183 29.0733 4.46833C31.5308 5.05483 30.7317 1.19533 32.8403 0.410829C34.2454 -0.111921 35.4011 0.527079 36.3079 2.32783C37.1108 0.647829 38.3343 -0.121671 39.9784 0.0155795C42.445 0.223329 43.3082 8.51158 46.6975 6.69733C50.0875 4.88233 54.2435 4.46758 56.0188 7.16458C56.4025 7.74808 56.5495 6.84283 59.1593 3.75208C61.7691 0.660579 64.3714 -0.701421 69.7101 1.09858C72.1375 1.91608 74.1337 4.13233 75.7009 7.74658C75.7009 12.9051 79.5154 15.9591 87.1428 16.9063C98.5854 18.3276 89.7036 30.5668 75.7009 34.1511C61.6975 37.7361 29.4577 39.6711 11.9625 30.6141C0.298974 24.5773 2.9495 18.0883 19.9133 11.1486H19.9141Z'
        fill='url(#paint0_linear_6027_509)'
      />
      <path
        d='M48.6053 56.7336C60.2574 56.7336 69.7032 54.5584 69.7032 51.8751C69.7032 49.1918 60.2574 47.0166 48.6053 47.0166C36.9533 47.0166 27.5074 49.1918 27.5074 51.8751C27.5074 54.5584 36.9533 56.7336 48.6053 56.7336Z'
        fill='url(#paint1_linear_6027_509)'
      />
      <path
        opacity='0.675'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M84.2246 57.9373C68.3614 61.8958 14.2149 57.3681 8.45177 55.3003C5.64671 54.2931 3.11831 52.3993 0.867321 49.6183C0.615386 49.3074 0.457028 48.9318 0.410548 48.5351C0.364069 48.1384 0.431363 47.7367 0.604656 47.3765C0.777949 47.0162 1.05017 46.7121 1.38985 46.4992C1.72954 46.2863 2.12283 46.1735 2.52428 46.1736H97.1425C99.1063 51.3771 94.8003 55.2981 84.2246 57.9373Z'
        fill='url(#paint2_linear_6027_509)'
      />
      <path
        d='M64.795 38.8543L57.5799 30.4603C57.4093 30.2601 57.1972 30.0988 56.9582 29.9875C56.7193 29.8761 56.459 29.8174 56.1951 29.8153H40.6809C40.1487 29.8153 39.6429 30.0583 39.2961 30.4603L32.0811 38.8543V43.4623H64.795V38.8543Z'
        fill='url(#paint3_linear_6027_509)'
      />
      <path
        d='M62.7505 43.6318L56.4356 36.3208C56.2829 36.1482 56.0947 36.0103 55.8837 35.9164C55.6727 35.8226 55.4439 35.7751 55.2128 35.777H41.6632C41.1981 35.777 40.7435 35.969 40.4405 36.3208L34.1255 43.6318V47.6473H62.7505V43.6318Z'
        fill='#E2EEE8'
      />
      <path
        d='M64.795 48.743C64.795 49.3828 64.5055 49.958 64.0486 50.3435L63.9559 50.4185C63.5937 50.6917 63.1515 50.8392 62.697 50.8385H34.1798C33.9219 50.8385 33.6754 50.792 33.4478 50.7065L33.3347 50.6615C32.9616 50.4964 32.6447 50.2272 32.4222 49.8866C32.1997 49.546 32.0812 49.1485 32.0811 48.7423V38.9045H40.0183C40.895 38.9045 41.6014 39.6223 41.6014 40.493V40.5043C41.6014 41.3758 42.316 42.0785 43.1927 42.0785H53.6833C54.1047 42.0781 54.5088 41.9116 54.807 41.6154C55.1053 41.3193 55.2734 40.9176 55.2746 40.4983C55.2746 39.6238 55.9817 38.9045 56.8577 38.9045H64.7957L64.795 48.743Z'
        fill='url(#paint4_linear_6027_509)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_6027_509'
          x1='50.664'
          y1='27.7125'
          x2='50.664'
          y2='-6.55011'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#DEDEDE' stopOpacity='0' />
          <stop offset='1' stopColor='#A9A9A9' stopOpacity='0.3' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_6027_509'
          x1='46.4069'
          y1='56.7336'
          x2='46.4069'
          y2='47.0166'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='#96A1C5' stopOpacity='0.373' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_6027_509'
          x1='49'
          y1='59.5074'
          x2='49'
          y2='43.5502'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='#919191' stopOpacity='0.15' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_6027_509'
          x1='48.438'
          y1='29.8153'
          x2='48.438'
          y2='35.9496'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#26A085' />
          <stop offset='1' stopColor='#00785D' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_6027_509'
          x1='48.4384'
          y1='38.9045'
          x2='48.4384'
          y2='50.8385'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#05AE88' />
          <stop offset='1' stopColor='#009977' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default noResultsIcon
